import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/historial_interno/historial_interno';   
import Listar from './Listar';

const ms2p = (state) => {
    return {
        ...state.historial_interno,
    };
};

const md2p = { ...actions} ;

export default connect(ms2p, md2p)(Listar);